import wrapper from 'wrapper';
import 'core-js/modules/es6.array.find';
import 'core-js/es6/promise';
import Buttons from './components/buttons/buttons';
import Dropdown from './components/dropdown/dropdown';

function init() {
    progressiveEnhance();
    wrapper.markPageAsLoaded();

    let dataURL = `https://www.bbc.co.uk/indepthtoolkit/data-sets/wslanguages_coronavirus_glossary_${wrapper.getConfig().language}/json-with-props`;
    if (wrapper.getConfig().language === 'english') dataURL = 'https://www.bbc.co.uk/indepthtoolkit/data-sets/coronavirus_glossary/json-with-props';

    window.fetch(dataURL)
        .then(response => response.json())
        .then((data) => {
            initDropdown(data);
        })
        .catch((error) => {
            new Error(`Error: ${error}`);
        });
}

function progressiveEnhance() {
    wrapper.select('#core-content').style.display = 'none';
    wrapper.select('#full-experience').style.display = 'block';
}


let buttonClickCount = 0;

function formatData(data) {
    return Object.keys(data).map((key, i) => ({
        value: key,
        id: i,
        definition: data[key].definition,
    }));
}

function initDropdown(data) {
    const jargonList = formatData(data);

    const getEntry = (id) => jargonList.filter(row => row.id === id);
    Dropdown.create({
        target: wrapper.select('.input-form'),
        options: jargonList,
        defaultText: __('choose-term'),
        onSelect: (id) => {
            const [entry] = getEntry(id);
            clearButtonSelection();
            showDefinition(entry);
        },
    });

    Buttons.create({
        data: jargonList,
        onButtonClick: (id) => {
            const [entry] = getEntry(id);
            wrapper.callIstats({
                actionType: 'selected-via-button',
                actionName: 'newsspec-interaction',
                viewLabel: entry.value,
            });
            buttonClickCount += 1;
            wrapper.callIstats({
                actionType: 'number-of-button-selects',
                actionName: 'newsspec-nonuser',
                viewLabel: buttonClickCount,
            });
            showDefinition(entry);
        },
    });
}

function clearButtonSelection() {
    Buttons.clearSelection();
}

function resetDropdown() {
    Dropdown.reset();
}

function showDefinition(searchTerm) {
    wrapper.select('.results-view').innerHTML = `
        <div class='divider'>
        <h2><span class="search-term">${searchTerm.value}</span></h2>
        <p>${searchTerm.definition}</p>
        <button class="button--reset">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14"><title>  Fill 1</title><g class="button--reset-svg"><path d="M6 1.7L5.6 1.7 6.4 0.9 5.6 0 3 2.6 5.6 5.1 6.4 4.3 5.6 3.4 6 3.4C8.4 3.4 10.3 5.4 10.3 7.7 10.3 10.1 8.4 12 6 12 3.6 12 1.7 10.1 1.7 7.7L0 7.7C0 11 2.7 13.7 6 13.7 9.3 13.7 12 11 12 7.7 12 4.4 9.3 1.7 6 1.7"/></g></svg>
            ${__('reset-button-text')}
        </button>
    `;
    [].slice.call(wrapper.selectAll('.button--reset')).forEach(resetButton => {
        resetButton.addEventListener('click', () => {
            resetView();
            wrapper.callIstats({
                actionType: 'reset-button-clicked',
                actionName: 'newsspec-interaction',
            });
        });
    });
}

function resetView() {
    clearButtonSelection();
    resetDropdown();
    wrapper.select('.results-view').innerHTML = '';
}

init();
